<template>
  <div class="tile is-ancestor is-vertical box is-12 zeromp">
    <div class="tile is-parent is-12 zeromp">
      <article class="tile is-child zeromp">
        <div class="content zeromp">
          <internnavbar />
        </div>
      </article>
    </div>
    <div class="tile is-vertical is-12 internbackground">
      <div class="tile is-parent is-vertical">
        <div class="tile is-child">
          <p class="indextitle">TEASER</p>

          <div class>
            <div class id="tabela-teaser">
              <b-button
                v-if="is_admin"
                class="is-white"
                tag="router-link"
                to="/admin/biblioteca/teaser/create"
                type="is-link"
              >ADICIONAR NOVO TEASER</b-button>
              <b-table :data="isEmpty ? [] : teasers" :hoverable="true" :checkable="true">
                <template slot-scope="props">
                  <!-- colunas-->

                  <b-table-column label="Título">{{ props.row.video.titulo }}</b-table-column>

                  <b-table-column label="Descrição">{{ props.row.video.descricao }}</b-table-column>

                  <b-table-column label="Escolas">
                    <span v-if="! Object.keys(props.row.escolas).length">Aberto</span>
                    <b-select v-else :placeholder="`Escolas disponiveis`" expanded>
                      <option
                        v-for="(nome, id) in props.row.escolas"
                        v-bind:key="id"
                        :value="id"
                      >{{ nome }}</option>
                    </b-select>
                  </b-table-column>

                  <b-table-column label="Tags">
                      <b-tag type="is-info"
                        v-for="(tag, key) in props.row.tags"
                        v-bind:key="key"
                        :value="key"
                      >{{ tag.nome }}</b-tag>
                  </b-table-column>

                  <b-table-column field="actions" label="Ações" width="180" centered>
                    <!-- detalhes -->
                    <b-tooltip label="Assitir" position="is-top" type="is-dark">
                      <button
                        class="button is-primary is-round"
                        id="info"
                        @click="video_url = props.row.video.url, isCardModalActive = true"
                      >
                        <b-icon icon="eye"></b-icon>
                      </button>
                    </b-tooltip>
                  </b-table-column>
                </template>
                <template slot="empty">
                  <section class="section">
                    <div class="content has-text-grey has-text-centered">
                      <p>
                        <i class="fas fa-frown-open" style="width:5em;height:5em;"></i>
                      </p>
                      <p>Nada aqui.</p>
                    </div>
                  </section>
                </template>
              </b-table>
            </div>
          </div>
          <b-modal :active.sync="isCardModalActive" style="width=729; height=425;">
            <div class>
              <div class="card-content">
                <iframe
                  allowfullscreen
                  width="100%"
                  v-bind:src=" 'https://player.vimeo.com/video/'  + video_url.split('/')[2]"
                ></iframe>
              </div>
            </div>
          </b-modal>
        </div>
        <internfooter />
      </div>
    </div>
  </div>
</template>

<script>
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";

export default {
  data() {
    return {
      isEmpty: false,
      video_url: "",
      isImageModalActive: false,
      isCardModalActive: false
    };
  },

  name: "TableTeaser",
  props: ["teasers", "is_admin"],
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter
  }
};
</script>
<style scoped>
iframe {
  height: 60vh;
}
</style>